module.exports = __webpack_public_path__ + "static/media/F_25_brochure_04_2020_compressed.5f2b1541.pdf";